export const defaultInfo = {}
export const defaultInternalLinks = []
export const defaultBreadcrumbs = []
export const defaultSeoContent = {}

export default {
  info: defaultInfo,
  internalLinks: defaultInternalLinks,
  breadcrumbs: defaultBreadcrumbs,
  seoContent: defaultSeoContent
}
